$(document).ready(function () {

    if (!$('#homepage-container').length) {
        return;
    }
    $('.homepage-topbanner-slider').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        mobileFirst: true,
        pauseOnHover: false,
        prevArrow: $("#prev-arrow"),
        nextArrow: $("#next-arrow"),
        appendDots: $("#dots-wrapper")
    });
})
